// @flow @jsx h

import { Component, h } from 'preact'
import { Question } from '../Question'

/* styles */
import styles from './index.css'
import appStyles from '../App.css'

/* types */
import type { FeedItem } from '../types'

type Props = {
  feed: FeedItem[],
  filter: Array<Mixed>,
  id: string,
  antall: number
}

export class Questions extends Component<Props> {
  elm: HTMLElement

  componentDidUpdate (prevProps: Props) {
    // Typical usage (don't forget to compare props):
    if (this.props.antall > prevProps.antall && this.elm.children.length > prevProps.antall) {
      const child = this.elm.children[prevProps.antall]
      child.scrollIntoView({ behavior: 'smooth', block: 'end' })
      setTimeout(() => {
        child.focus()
      }, 300)
    }
  }

  getFilteredItems () {
    const { filter, feed, antall, id } = this.props
    const bySlug = feedItem => {
      if (!filter) {
        return true
      }

      const tags = feedItem.data.superTags || []
      return !!tags.find(superTag => superTag.slug === filter)
    }
    const selectedIdFirst = (a, b) => a.id === id ? -1 : b.id === id ? 1 : 0

    return feed.filter(bySlug)
      .sort(selectedIdFirst)
      .slice(0, antall)
  }

  render () {
    const { filter, antall, id } = this.props
    const showMoreUrl = filter ? `#/filter/${filter}?antall=${antall + 10}` : `#/?antall=${antall + 10}`
    let items = this.getFilteredItems()
    return (
      <div class={styles.questions + ' ' + appStyles.app__element} ref={elm => (this.elm = elm)}>
        {
          items.map(feedItem => {
            switch (feedItem.type) {
              case 'question':
                return <Question key={feedItem.id} feedItem={feedItem} initiallyOpen={feedItem.id === id} />
              default:
                return <div>Ukjent feed item</div>
            }
          })
        }
        {items.length === antall && (
          <div class={styles.questions__pagination + ' nrk-pagination'}>
            <a href={showMoreUrl} class='nrk-button nrk-color-base'>
              <span class={styles.button_icon}>+</span>
              <span>Vis flere</span>
            </a>
          </div>
        )}
      </div>
    )
  }
}
